import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button } from "reactstrap";
import "./index.scss";
import { documentLabelPanelAction } from "../../context/actions/documentLabelPanelAction";
import { tempAction } from "../../context/actions/tempAction";
const DocumentLabels = () => {
  const history = useHistory();
  const role = useSelector((state) => state?.user?.user?.role);
  const [userRole, setUserRole] = useState(role);

  useEffect(() => {
    let isMounted = true; // Add a boolean flag to track component mount state

    if (userRole !== "business" && userRole !== "operator") {
      history.push("/unauthorized");
    }

    return () => {
      isMounted = false; // Set the flag to false when the component unmounts
    };
  }, [userRole, history]);

  const documentLabelPanelOnState = useSelector(
    (state) => state.documentLabelPanelReducer.documentLabelPanelOn
  );
  const dispatch = useDispatch();

  const documentLabelPanelHandler = () => {
    dispatch(documentLabelPanelAction(!documentLabelPanelOnState));
  };
  const overlayHandler = () => {
    dispatch(documentLabelPanelAction(false));
  };
  useEffect(() => {
    dispatch(tempAction({}));
  }, []);
  return (
    <>
      <div
        className={`document-label-panel-overlay position-fixed ${
          documentLabelPanelOnState ? "active" : ""
        }`}
        onClick={overlayHandler}
      ></div>
      <div className="page-wrapper document-page-wrapper d-flex flex-column flex-fill overflow-auto">
        <div className="page-header-wrapper">
          <div className="page-header d-flex">
            <div className="left-colum">
              <Button
                color="link"
                className="document-panel-btn"
                onClick={documentLabelPanelHandler}
              >
                <FontAwesomeIcon icon={faBars} />
              </Button>
            </div>
            <div className="right-colum">
              <h2 className="d-flex align-items-center">
                Document Labels Support
              </h2>
              <h3>Complete label Descrition.</h3>
            </div>
          </div>
        </div>
        <div className="inner-wrapper2 d-flex flex-column flex-fill overflow-auto">
          <div className="document-label-blc d-flex flex-fill overflow-auto">
            <div
              className={`left-col overflow-auto ${
                documentLabelPanelOnState ? "active" : ""
              }`}
            >
              <div className="label-block">
                <h2>Document Label </h2>
                <div className="inner">
                  <Button color="link" className="active">
                    Loan Number
                  </Button>
                  <Button color="link">Purchase Date</Button>
                  <Button color="link">Seller Loan Number</Button>
                  <Button color="link">Purchase Date</Button>
                  <Button color="link">Borrower Name</Button>
                  <Button color="link">Loan Amount Original</Button>
                </div>
              </div>
            </div>
            <div className="right-col flex-fill  overflow-auto">
              <div className="label-des-blc">
                <h2>Loan Number</h2>
                <div className="inner">
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book. It has survived not only five centuries,
                    but also the leap into electronic typesetting, remaining
                    essentially unchanged.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DocumentLabels;
